import * as i0 from '@angular/core';
import { EventEmitter, Component, Output, Input, PLATFORM_ID, ViewEncapsulation, Inject, ContentChild, NgModule } from '@angular/core';
import { __decorate } from 'tslib';
import { JSReportViewerBinding } from 'devexpress-reporting/dx-webdocumentviewer';
import * as ko from 'knockout';
import { _inputConverter, _booleanConverter, DxReportingComponent } from 'devexpress-reporting-angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class DxReportViewerCallbacksComponent {
    constructor() {
        this.CustomizeElements = new EventEmitter();
        this.PreviewClick = new EventEmitter();
        this.EditingFieldChanged = new EventEmitter();
        this.DocumentReady = new EventEmitter();
        this.CustomizeExportOptions = new EventEmitter();
        this.CustomizeParameterEditors = new EventEmitter();
        this.CustomizeParameterLookUpSource = new EventEmitter();
        this.ParametersReset = new EventEmitter();
        this.ParametersSubmitted = new EventEmitter();
        this.ParametersInitialized = new EventEmitter();
        this.CustomizeMenuActions = new EventEmitter();
        this.CustomizeLocalization = new EventEmitter();
        this.OnInitializing = new EventEmitter();
        this.BeforeRender = new EventEmitter();
        this.OnServerError = new EventEmitter();
        this.OnExport = new EventEmitter();
    }
}
DxReportViewerCallbacksComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportViewerCallbacksComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxReportViewerCallbacksComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: DxReportViewerCallbacksComponent, selector: "dxrv-callbacks", outputs: { CustomizeElements: "CustomizeElements", PreviewClick: "PreviewClick", EditingFieldChanged: "EditingFieldChanged", DocumentReady: "DocumentReady", CustomizeExportOptions: "CustomizeExportOptions", CustomizeParameterEditors: "CustomizeParameterEditors", CustomizeParameterLookUpSource: "CustomizeParameterLookUpSource", ParametersReset: "ParametersReset", ParametersSubmitted: "ParametersSubmitted", ParametersInitialized: "ParametersInitialized", CustomizeMenuActions: "CustomizeMenuActions", CustomizeLocalization: "CustomizeLocalization", OnInitializing: "OnInitializing", BeforeRender: "BeforeRender", OnServerError: "OnServerError", OnExport: "OnExport" }, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportViewerCallbacksComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                    selector: 'dxrv-callbacks'
                }]
        }], propDecorators: { CustomizeElements: [{
                type: Output
            }], PreviewClick: [{
                type: Output
            }], EditingFieldChanged: [{
                type: Output
            }], DocumentReady: [{
                type: Output
            }], CustomizeExportOptions: [{
                type: Output
            }], CustomizeParameterEditors: [{
                type: Output
            }], CustomizeParameterLookUpSource: [{
                type: Output
            }], ParametersReset: [{
                type: Output
            }], ParametersSubmitted: [{
                type: Output
            }], ParametersInitialized: [{
                type: Output
            }], CustomizeMenuActions: [{
                type: Output
            }], CustomizeLocalization: [{
                type: Output
            }], OnInitializing: [{
                type: Output
            }], BeforeRender: [{
                type: Output
            }], OnServerError: [{
                type: Output
            }], OnExport: [{
                type: Output
            }] } });

class DxReportViewerRequestOptionsComponent {
    constructor() {
        this.invokeAction = '/DXXRDV';
    }
}
DxReportViewerRequestOptionsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportViewerRequestOptionsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxReportViewerRequestOptionsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: DxReportViewerRequestOptionsComponent, selector: "dxrv-request-options", inputs: { invokeAction: "invokeAction", getLocalizationAction: "getLocalizationAction", host: "host" }, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportViewerRequestOptionsComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                    selector: 'dxrv-request-options'
                }]
        }], propDecorators: { invokeAction: [{
                type: Input
            }], getLocalizationAction: [{
                type: Input
            }], host: [{
                type: Input
            }] } });

class DxReportViewerExportSettingsComponent {
    getSerializableSettings() {
        return {
            useSameTab: this.useSameTab,
            useAsynchronousExport: this.useAsynchronousExport,
            showPrintNotificationDialog: this.showPrintNotificationDialog
        };
    }
}
DxReportViewerExportSettingsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportViewerExportSettingsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxReportViewerExportSettingsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: DxReportViewerExportSettingsComponent, selector: "dxrv-export-settings", inputs: { useSameTab: "useSameTab", useAsynchronousExport: "useAsynchronousExport", showPrintNotificationDialog: "showPrintNotificationDialog" }, ngImport: i0, template: '', isInline: true });
__decorate([
    _inputConverter(_booleanConverter)
], DxReportViewerExportSettingsComponent.prototype, "useSameTab", void 0);
__decorate([
    _inputConverter(_booleanConverter)
], DxReportViewerExportSettingsComponent.prototype, "useAsynchronousExport", void 0);
__decorate([
    _inputConverter(_booleanConverter)
], DxReportViewerExportSettingsComponent.prototype, "showPrintNotificationDialog", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportViewerExportSettingsComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                    selector: 'dxrv-export-settings'
                }]
        }], propDecorators: { useSameTab: [{
                type: Input
            }], useAsynchronousExport: [{
                type: Input
            }], showPrintNotificationDialog: [{
                type: Input
            }] } });

class DxReportViewerMobileModeSettingsComponent {
}
DxReportViewerMobileModeSettingsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportViewerMobileModeSettingsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxReportViewerMobileModeSettingsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: DxReportViewerMobileModeSettingsComponent, selector: "dxrv-mobile-mode-settings", inputs: { readerMode: "readerMode", animationEnabled: "animationEnabled" }, ngImport: i0, template: '', isInline: true });
__decorate([
    _inputConverter(_booleanConverter)
], DxReportViewerMobileModeSettingsComponent.prototype, "readerMode", void 0);
__decorate([
    _inputConverter(_booleanConverter)
], DxReportViewerMobileModeSettingsComponent.prototype, "animationEnabled", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportViewerMobileModeSettingsComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                    selector: 'dxrv-mobile-mode-settings'
                }]
        }], propDecorators: { readerMode: [{
                type: Input
            }], animationEnabled: [{
                type: Input
            }] } });

class DxReportViewerProgressBarSettingsComponent {
    getSerializableSettings() {
        return {
            position: this.position,
            keepOnVisibleArea: this.keepOnVisibleArea,
        };
    }
}
DxReportViewerProgressBarSettingsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportViewerProgressBarSettingsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxReportViewerProgressBarSettingsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: DxReportViewerProgressBarSettingsComponent, selector: "dxrv-progressbar-settings", inputs: { position: "position", keepOnVisibleArea: "keepOnVisibleArea" }, ngImport: i0, template: '', isInline: true });
__decorate([
    _inputConverter(_booleanConverter)
], DxReportViewerProgressBarSettingsComponent.prototype, "keepOnVisibleArea", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportViewerProgressBarSettingsComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                    selector: 'dxrv-progressbar-settings'
                }]
        }], propDecorators: { position: [{
                type: Input
            }], keepOnVisibleArea: [{
                type: Input
            }] } });

class DxReportViewerRemoteSettingsComponent {
}
DxReportViewerRemoteSettingsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportViewerRemoteSettingsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxReportViewerRemoteSettingsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: DxReportViewerRemoteSettingsComponent, selector: "dxrv-remote-settings", inputs: { authToken: "authToken", serverUri: "serverUri" }, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportViewerRemoteSettingsComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                    selector: 'dxrv-remote-settings'
                }]
        }], propDecorators: { authToken: [{
                type: Input
            }], serverUri: [{
                type: Input
            }] } });

class DxReportViewerTabPanelSettingsComponent {
}
DxReportViewerTabPanelSettingsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportViewerTabPanelSettingsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxReportViewerTabPanelSettingsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: DxReportViewerTabPanelSettingsComponent, selector: "dxrv-tabpanel-settings", inputs: { position: "position", width: "width" }, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportViewerTabPanelSettingsComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                    selector: 'dxrv-tabpanel-settings'
                }]
        }], propDecorators: { position: [{
                type: Input
            }], width: [{
                type: Input
            }] } });

class DxReportViewerSearchSettingsComponent {
    getSerializableSettings() {
        return {
            useAsyncSearch: this.useAsyncSearch,
            searchEnabled: this.searchEnabled
        };
    }
}
DxReportViewerSearchSettingsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportViewerSearchSettingsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DxReportViewerSearchSettingsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: DxReportViewerSearchSettingsComponent, selector: "dxrv-search-settings", inputs: { searchEnabled: "searchEnabled", useAsyncSearch: "useAsyncSearch" }, ngImport: i0, template: '', isInline: true });
__decorate([
    _inputConverter(_booleanConverter)
], DxReportViewerSearchSettingsComponent.prototype, "searchEnabled", void 0);
__decorate([
    _inputConverter(_booleanConverter)
], DxReportViewerSearchSettingsComponent.prototype, "useAsyncSearch", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportViewerSearchSettingsComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                    selector: 'dxrv-search-settings'
                }]
        }], propDecorators: { searchEnabled: [{
                type: Input
            }], useAsyncSearch: [{
                type: Input
            }] } });

class DxReportViewerComponent extends DxReportingComponent {
    constructor(renderer, platformId) {
        super(renderer, platformId);
        this.koReportUrl = ko.observable();
    }
    getKoBinding(options) {
        return new JSReportViewerBinding(options, this.getEventRaiser());
    }
    getCallbacks() {
        return this.callbacksComponent;
    }
    getControlOptions() {
        return {
            rtl: this.rtl,
            developmentMode: this.developmentMode,
            isMobile: this.isMobile,
            accessibilityCompliant: this.accessibilityCompliant,
            reportUrl: this.koReportUrl,
            requestOptions: this.requestOptionsComponent,
            mobileModeSettings: this.mobileModeSettingsComponent,
            remoteSettings: this.remoteSettingsComponent,
            tabPanelSettings: this.tabPanelSettingsComponent,
            progressBarSettings: this.progressBarSettingsComponent,
            exportSettings: this.exportSettingsComponent,
            keepReportOnComponentDisposal: this.keepReportOnComponentDisposal,
            searchSettings: this.searchSettingsComponent,
            callbacks: {}
        };
    }
    GetPreviewModel() {
        return this.bindingSender.GetPreviewModel();
    }
    get reportUrl() {
        return this.koReportUrl();
    }
    set reportUrl(reportUrl) {
        this.koReportUrl(reportUrl);
    }
}
DxReportViewerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportViewerComponent, deps: [{ token: i0.Renderer2 }, { token: PLATFORM_ID }], target: i0.ɵɵFactoryTarget.Component });
DxReportViewerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: DxReportViewerComponent, selector: "dx-report-viewer", inputs: { isMobile: "isMobile", accessibilityCompliant: "accessibilityCompliant", keepReportOnComponentDisposal: "keepReportOnComponentDisposal", reportUrl: "reportUrl" }, queries: [{ propertyName: "requestOptionsComponent", first: true, predicate: DxReportViewerRequestOptionsComponent, descendants: true }, { propertyName: "callbacksComponent", first: true, predicate: DxReportViewerCallbacksComponent, descendants: true }, { propertyName: "mobileModeSettingsComponent", first: true, predicate: DxReportViewerMobileModeSettingsComponent, descendants: true }, { propertyName: "remoteSettingsComponent", first: true, predicate: DxReportViewerRemoteSettingsComponent, descendants: true }, { propertyName: "tabPanelSettingsComponent", first: true, predicate: DxReportViewerTabPanelSettingsComponent, descendants: true }, { propertyName: "progressBarSettingsComponent", first: true, predicate: DxReportViewerProgressBarSettingsComponent, descendants: true }, { propertyName: "exportSettingsComponent", first: true, predicate: DxReportViewerExportSettingsComponent, descendants: true }, { propertyName: "searchSettingsComponent", first: true, predicate: DxReportViewerSearchSettingsComponent, descendants: true }], usesInheritance: true, ngImport: i0, template: "<div #control [ngClass]=\"cssClass\" [ngStyle]=\"{'width': width, 'height': height }\">\r\n  <div data-bind=\"dxReportViewer: $data\"></div>\r\n</div>", directives: [{ type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], encapsulation: i0.ViewEncapsulation.None });
__decorate([
    _inputConverter(_booleanConverter)
], DxReportViewerComponent.prototype, "isMobile", void 0);
__decorate([
    _inputConverter(_booleanConverter)
], DxReportViewerComponent.prototype, "accessibilityCompliant", void 0);
__decorate([
    _inputConverter(_booleanConverter)
], DxReportViewerComponent.prototype, "keepReportOnComponentDisposal", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportViewerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'dx-report-viewer',
                    encapsulation: ViewEncapsulation.None,
                    templateUrl: './dx-report-viewer.component.html',
                    styleUrls: []
                }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: Object, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }]; }, propDecorators: { requestOptionsComponent: [{
                type: ContentChild,
                args: [DxReportViewerRequestOptionsComponent]
            }], callbacksComponent: [{
                type: ContentChild,
                args: [DxReportViewerCallbacksComponent]
            }], mobileModeSettingsComponent: [{
                type: ContentChild,
                args: [DxReportViewerMobileModeSettingsComponent]
            }], remoteSettingsComponent: [{
                type: ContentChild,
                args: [DxReportViewerRemoteSettingsComponent]
            }], tabPanelSettingsComponent: [{
                type: ContentChild,
                args: [DxReportViewerTabPanelSettingsComponent]
            }], progressBarSettingsComponent: [{
                type: ContentChild,
                args: [DxReportViewerProgressBarSettingsComponent]
            }], exportSettingsComponent: [{
                type: ContentChild,
                args: [DxReportViewerExportSettingsComponent]
            }], searchSettingsComponent: [{
                type: ContentChild,
                args: [DxReportViewerSearchSettingsComponent]
            }], isMobile: [{
                type: Input
            }], accessibilityCompliant: [{
                type: Input
            }], keepReportOnComponentDisposal: [{
                type: Input
            }], reportUrl: [{
                type: Input
            }] } });

class DxReportViewerModule {
}
DxReportViewerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportViewerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DxReportViewerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportViewerModule, declarations: [DxReportViewerComponent,
        DxReportViewerCallbacksComponent,
        DxReportViewerMobileModeSettingsComponent,
        DxReportViewerRemoteSettingsComponent,
        DxReportViewerRequestOptionsComponent,
        DxReportViewerProgressBarSettingsComponent,
        DxReportViewerExportSettingsComponent,
        DxReportViewerTabPanelSettingsComponent,
        DxReportViewerSearchSettingsComponent], imports: [CommonModule], exports: [DxReportViewerComponent,
        DxReportViewerCallbacksComponent,
        DxReportViewerMobileModeSettingsComponent,
        DxReportViewerRemoteSettingsComponent,
        DxReportViewerRequestOptionsComponent,
        DxReportViewerProgressBarSettingsComponent,
        DxReportViewerExportSettingsComponent,
        DxReportViewerTabPanelSettingsComponent,
        DxReportViewerSearchSettingsComponent], id: 'DxReportViewerModule' });
DxReportViewerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportViewerModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: DxReportViewerModule, decorators: [{
            type: NgModule,
            args: [{
                    id: 'DxReportViewerModule',
                    imports: [CommonModule],
                    declarations: [
                        DxReportViewerComponent,
                        DxReportViewerCallbacksComponent,
                        DxReportViewerMobileModeSettingsComponent,
                        DxReportViewerRemoteSettingsComponent,
                        DxReportViewerRequestOptionsComponent,
                        DxReportViewerProgressBarSettingsComponent,
                        DxReportViewerExportSettingsComponent,
                        DxReportViewerTabPanelSettingsComponent,
                        DxReportViewerSearchSettingsComponent
                    ],
                    exports: [
                        DxReportViewerComponent,
                        DxReportViewerCallbacksComponent,
                        DxReportViewerMobileModeSettingsComponent,
                        DxReportViewerRemoteSettingsComponent,
                        DxReportViewerRequestOptionsComponent,
                        DxReportViewerProgressBarSettingsComponent,
                        DxReportViewerExportSettingsComponent,
                        DxReportViewerTabPanelSettingsComponent,
                        DxReportViewerSearchSettingsComponent
                    ]
                }]
        }] });

/*
 * Public API Surface of reporting-angular/report-viewer
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DxReportViewerCallbacksComponent, DxReportViewerComponent, DxReportViewerExportSettingsComponent, DxReportViewerMobileModeSettingsComponent, DxReportViewerModule, DxReportViewerProgressBarSettingsComponent, DxReportViewerRemoteSettingsComponent, DxReportViewerRequestOptionsComponent, DxReportViewerSearchSettingsComponent, DxReportViewerTabPanelSettingsComponent };
